export default __webpack_public_path__ + "static/media/fc6_logo_TCH.6c36a691.png";